export const buildInfo = {
    "version": "0.3.1",
    "environment": "prod",
    "commitShortSha": "ba993e7d",
    "commitTimestamp": "2026-09-26 23:03:39 +0200"
} as const;
